export default __webpack_public_path__ + "static/media/Cubs.79e0143d.png";